import apiClient from '@/utils/request'

export interface IIsp {
  country_name: string
  country_code: string
  isp_name: string
  connection_types?: string[]
}

export interface IIspsResponse {
  data: IIsp[]
}

export const fetchItems = async (): Promise<IIspsResponse> => {
  const response = await apiClient.get<IIspsResponse>('/isps')
  return response.data
}
